export const getElementWidth = (el: HTMLElement | null | undefined): number => el?.offsetWidth ?? 0

export const sumAryValues = (values: number[]): number => values.reduce((res, v) => res + v, 0)
